import clsx from 'clsx';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  repairRecommendationsList: any[];
}

const RepairRecommendations = ({ repairRecommendationsList }: Props) => {
  return (
    <div className={clsx(classes.sectionBox, classes.noMargin)}>
      <div className={classes.sectionTitle}>
        <div className={classes.repairTitleColumn}>Repair Recommendations</div>
        <div className={classes.repairQuantityColumn}>Quantity</div>
        <div className={classes.repairUnitsColumn}>Units</div>
        <div className={classes.repairPriorityColumn}>Repair Priority</div>
      </div>
      <div className={classes.repairContent}>
        {repairRecommendationsList.map(item => {
          return (
            <div className={classes.repairRow} key={item.repairRecommendation}>
              <div className={classes.repairTitleColumn}>
                {item.repairRecommendation}
              </div>
              <div className={classes.repairQuantityColumn}>
                {item.quantity}
              </div>
              <div className={classes.repairUnitsColumn}>{item.unit}</div>
              <div className={classes.repairPriorityColumn}>
                {item.repairPriority}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RepairRecommendations;
